import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectActiveOrganization} from "../../../store/reducers/auth/authReducer";
import {loadItemAsync} from "../../../store/reducers/item/itemReducer";
import EventBus from "../../../eventbus/EventBus";
import {EDIT_ITEM_SUCCESS} from "../../../eventbus/itemEvents";
import EditItemForm from "../../../components/item/components/EditItemForm";

const EditItem = () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const activeOrganization = useSelector(selectActiveOrganization);

    const [item, setItem] = useState(null);

    // load item
    useEffect(() => {
        loadItemAsync(id)
            .then((item) => {
                setItem(item);
            })
            .catch(() => {
                setItem(null);
            })

        const onItemEditedHandler = EventBus.on(EDIT_ITEM_SUCCESS, (id) => {
            navigate('/items');
        })

        return () => {
            EventBus.remove(EDIT_ITEM_SUCCESS, onItemEditedHandler);
        }
    }, [id, activeOrganization])

    if (!item)
        return null;

    return (
        <EditItemForm item={item} />
    );
};

export default EditItem;
